var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-button",class:[_vm.widthClass, _vm.buttonClass]},[_c('b-button',{staticClass:"rounded-pill position-relative",class:{
          'button-opacity': _vm.loading,
          'align-items-end': _vm.type === 'filter',
  
        },attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.type === 'add')?_c('img',{attrs:{"src":require("../assets/images/common/add-plus.svg"),"alt":""}}):_vm._e(),(_vm.type === 'withdraw')?_c('img',{attrs:{"src":require("../assets/images/common/withdrawl.svg"),"alt":""}}):_vm._e(),_c('span',{staticClass:"text-nowrap text-capitalize",class:{
          'invisible':_vm.loading
        }},[_vm._v(" "+_vm._s(_vm.text))]),(_vm.loading)?_c('div',{staticClass:"loader-position"},[_c('Loader')],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }